export default __webpack_public_path__ + "static/media/1758.ec423436.png";